import "./SinglePostTemplate.module.css"
import HeaderNavigazione from "@/reusable_sections/Header"
import SinglePostTemplateSection from "./sections/SinglePostTemplateSection"
import Footer from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <HeaderNavigazione />
      <SinglePostTemplateSection />
      <Footer />
    </div>
  )
}
